module.exports = __webpack_public_path__ + "media/bootstrap-icons/cpu-8dc572c8.svg";